import { gql } from '@urql/core';
import { createQueryKeys } from '@lukemorales/query-key-factory';

export const billingFeatureKeys = createQueryKeys('billing', {
  pricingGrid: null,
});

export const pricingGridQuery = () => ({
  ...billingFeatureKeys.pricingGrid,
  meta: {
    query: gql`
      query PricingGrid {
        pricingGrid {
          plans {
            name
            label
            monthly {
              price
              stripeId
              semrushId
              recordingsAddon {
                productId
                planSlug
                stripeId
                tiers {
                  quantity
                  price
                }
              }
            }
            yearly {
              price
              stripeId
              semrushId
              recordingsAddon {
                productId
                planSlug
                stripeId
                tiers {
                  quantity
                  price
                }
              }
            }
            features
          }
          currentPlan
          showAddOnHeatmaps
          availableIntervals
          paymentProvider
        }
      }
    `,
  },
});
